/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { takeUntil, tap } from 'rxjs/operators';
import {
  PortfolioEntity,
  PortfolioSetupService,
} from '../../settings/portfolio-setup/portfolio-setup-service';
import { SettingsUtilsService } from '../../settings/settings-utils.service';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-mobile-portfolio-setup',
  templateUrl: './mobile-portfolio-setup.component.html',
  styleUrls: ['./mobile-portfolio-setup.component.scss'],
})
export class MobilePortfolioSetupComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  portfolioName$: Observable<string>;
  selectedEntities$: Observable<PortfolioEntity[]>;
  items$: Observable<any>;
  loading$: Observable<boolean>;
  isValid$: Observable<boolean>;

  constructor(
    private settingsUtils: SettingsUtilsService,
    public portfolioSetupService: PortfolioSetupService,
    private bottomSheetRef: MatBottomSheetRef<MobilePortfolioSetupComponent>,
  ) {
    this.portfolioName$ = this.portfolioSetupService.portfolioName$;
    this.selectedEntities$ = this.portfolioSetupService.selectedEntities$;
    this.items$ = this.portfolioSetupService.items$;
    this.loading$ = this.portfolioSetupService.loading$;
    this.isValid$ = this.portfolioSetupService.isValid$();
  }

  ngOnInit() {
    this.portfolioSetupService.clearSelection();
  }

  ngOnDestroy() {
    this.closeBottomSheet();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPortfolioNameChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.portfolioSetupService.setPortfolioName(inputElement.value);
  }

  optSelect(option: any): void {
    this.portfolioSetupService.addSelectedEntity(option);
  }

  removeEntity(id: string): void {
    this.portfolioSetupService.removeEntity(id);
  }
  createPortfolio(): void {
    this.portfolioSetupService
      .createPortfolio()
      .pipe(
        takeUntil(this.destroy$),
        tap({
          next: () => {
            this.portfolioSetupService.clearSelection();
            this.portfolioSetupService.setSetUpComplete(true);
            this.closeBottomSheet();
          },
          error: (error) => {
            console.error('Portfolio creation failed:', error);
          },
        }),
      )
      .subscribe();
  }
  defaultPortfolio(): void {
    this.portfolioSetupService
      .defaultPortfolio()
      .pipe(
        takeUntil(this.destroy$),
        tap({
          next: () => {
            this.portfolioSetupService.setSetUpComplete(true);
            this.closeBottomSheet();
          },
          error: (error) => {
            console.error('Portfolio creation failed:', error);
          },
        }),
      )
      .subscribe();
  }

  iMatch(entity) {
    return this.settingsUtils.iMatch(entity);
  }

  numberFormat(num) {
    if (num === undefined || num === null) {
      return '';
    }
    return this.settingsUtils.numberFormat(num);
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  get searchFormControl() {
    return this.portfolioSetupService.searchFormControl;
  }
}
